// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components
import EducationCard from "./EducationCard"

// Data / Images / Icons
import { EDUCATION } from "src/data/pages/education"

function EducationCardGroup() {
  return (
    <div className="max-w-3xl mx-auto px-6">
        <div className="space-y-4">
          {EDUCATION.map((edu) => (
            <EducationCard key={edu.id} education={edu} />
          ))}
        </div>
      </div>
  )
}

export default EducationCardGroup